import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useVoteData } from '../../context/VoteDataContext';
import SideNav from '../SideNav/SideNav';
import LeaderboardVoteProgression from './LeaderboardVoteProgression';

const VoteProgression = () => {
  const { token, isAuthenticated } = useAuth();
  const { data: voteData, isLoading: isVoteLoading, error: voteError, fetchVoteData } = useVoteData();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Vote data is cached in context; fetch only when landing here directly.
  useEffect(() => {
    const t = token && token();
    if (isAuthenticated && t && !voteData) {
      fetchVoteData(t);
    }
  }, [isAuthenticated, token, voteData, fetchVoteData]);

  return (
    <div className="min-h-screen bg-[#020817] text-white">
      {/* Navigation */}
      <SideNav
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Vote Progression Content */}
      <div className="md:ml-[var(--sidenav-width)] md:transition-[margin-left] md:duration-200 md:ease-out pt-3 md:pt-6 pb-20 md:pb-0">
        {isVoteLoading && (
          <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-3 md:px-6">
            <div className="animate-spin rounded-full h-12 w-12 border-2 border-gray-700 border-t-green-400" />
          </div>
        )}
        {voteError && (
          <div className="px-3 md:px-6 pb-6">
            <div className="bg-red-900/30 border border-red-500 text-red-300 rounded-lg p-3 text-sm">{voteError}</div>
          </div>
        )}
        {!isVoteLoading && (
          <div className="px-3 md:px-6 pb-6">
            <LeaderboardVoteProgression voteDataRemote={voteData} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VoteProgression;
